import { Container } from "react-bootstrap";

export default function FooterContainer() {
    return (
        <footer className="bg-accent">
            <div className='container text-light text-center py-3 readability d-md-flex justify-content-center'>
                <span>© 2024 - Caterina Vivarelli</span>
            </div>
        </footer>
    );
}